<template>
  <div>
    <div class="select-wrap">
      <div>
        <span>交易时间</span>
        <el-date-picker
          v-model="time"
          @change="onChangeTime"
          :clearable="false"
          unlink-panels
          type="daterange"
          format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small">
        </el-date-picker>
      </div>
      <div class="select-company">
        <span>交易类型</span>
         <el-select clearable v-model="trxType" size="small" placeholder="请选择交易类型">
            <el-option
              v-for="item in trxOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
        </el-select>
      </div>
      <div>
          <el-button type="primary" @click="getData" size="small">查询</el-button>
          <el-button type="primary" @click="exportDetail" size="small">导出明细</el-button>
      </div>
    </div>
    <div class="jzbWrap">
      <el-table :data="tableData" style="width: 100%" v-loading="loading"  @expand-change="expandChange">
        <el-table-column type="expand" >
          <template slot-scope="props">
            <div>
              <el-table :data="props.row.child" style="width:100%">
                <el-table-column prop="serialNum" label="序号">
                  </el-table-column>
                <el-table-column prop="saleOrder" label="销售单号/退货单号">
                </el-table-column>
                <el-table-column prop="skuCode" label="商品编码">
                </el-table-column>
                <el-table-column prop="skuName" label="商品名称">
                </el-table-column>
                <el-table-column prop="price" label="单价">
                </el-table-column>
                <el-table-column prop="quantity" label="数量">
                </el-table-column>
                <el-table-column prop="totalAmount" label="总金额">
                </el-table-column>
              
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createdOn" label="交易时间">
          <template slot-scope="scope">
            {{moment(scope.row.tradeTime).format('YYYY-MM-DD')}}
          </template>
        </el-table-column>
        <el-table-column prop="operationType" label="交易类型">
          <template slot-scope="scope">
            {{scope.row.trxType | filterOperationType}}
          </template>
        </el-table-column>
        <el-table-column prop="settleNo" label="单号"></el-table-column>
        <el-table-column prop="amount" label="交易金额">
          <template slot-scope="scope">
            {{scope.row.amount}}
          </template>
        </el-table-column>
        <el-table-column prop="operationType" label="转账状态">
          <template slot-scope="scope" v-if="scope.row.trxType === 6">
            {{scope.row.transferStatus | filterTransferType}}
          </template>
        </el-table-column>
        <el-table-column prop="payType" label="支付方式"></el-table-column>
        <el-table-column prop="chargeType" label="费用类型">
        </el-table-column>
        <el-table-column prop="corpName" label="公司"></el-table-column>
      </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
// cosnt disabledDate = current => current && current > moment().endOf('day') || current < moment().subtract(3, 'months')
import moment from 'moment'
import {r4gysCorpList, r4gysSettleTransaction, r4gysSettleTransactionDetail} from "@/models/r4UserModel";
import {buildURL} from "@/utils/utils";
import jzbApi from "@/service/basic/jzbApiList";

export default {
  props: {
    detailInfo: {
      activeCorp: '',
      activeName: '',
    }
  },
  data () {
    return {
      loading: false,
      expandLoading: false,
      tableData: [],
      time: [moment().subtract(3, 'months').valueOf(), moment().valueOf()],
      currentPage: 1,
      totalCount: 0,
      pagesize: 10,
      trxOptions: [
        {
          id: '1',
          name: '销售入账/退货扣款'
        },
        {
          id: '6',
          name: '提现'
        },
        {
          id: '2',
          name: '线下费用'
        }
      ],
      trxType: '',
      detailData: []
    }
  },

  filters: {
    filterOperationType (val) {
      let str = ''
      switch (val) {
        case 1:
          str = '销售入账/退货扣款';
          break
        case 6:
          str = '提现';
          break
        case 2:
          str = '线下费用';
          break

        default:
          break
      }
      return str
    },
    
    filterTransferType(val) {
      let str = ''
      switch (val) {
        case 0:
          str = '未转账';
          break
        case 1:
          str = '已转账';
          break
        case 2:
          str = '转账失败';
          break
        default:
          break
      }
      return str
    }

  },

  methods: {
    moment,
    onChangeTime (value) {
      this.time = value;
      let time = [];
      time[0] = Object.assign({}, moment(value[0]));
      time[1] = Object.assign({}, moment(value[1]));
      let startTime = moment(time[0]);
      let endtTime = moment(time[1]).subtract(1, 'days');
      if (!endtTime.subtract(3, 'months').isBefore(startTime)) {
        this.$message.error('选择的时间跨度最大为3个月');
        this.time = [moment().subtract(3, 'months').valueOf(), moment().valueOf()];
      } else {
        this.time = value;
      }
    },

    // 查询
    getData () {
      this.currentPage = 1;
      this.initData();
    },

    // 初始化锐锢交易明细列表数据
   initData () {
      this.loading = true;
      let params = {
        tradeType: this.type,
        supplierId: Number(localStorage.getItem('supplier_id')),
        corpId: this.detailInfo.activeCorp,
        page: this.currentPage - 1,
        pageSize: this.pagesize,
        trxType: this.trxType,
      }
      if (this.time.length === 0) {
        params.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD') + " 00:00:00"
        params.endDate = moment().format('YYYY-MM-DD') + " 23:59:59"
      } else {
        params.startDate = moment(this.time[0]).format('YYYY-MM-DD') + " 00:00:00"
        params.endDate = moment(this.time[1]).format('YYYY-MM-DD') + " 23:59:59"
      }
      r4gysSettleTransaction(params).then(res => {
        this.tableData = res ? res.data.content.map((item, index) => {
          item.child = [];       // 先给一个空值
          item.expand = false;   // 表示当前行是闭合的，不设置这个等下展开后就没法闭合了
          return item;
        }) : []
        this.totalCount = parseInt(res.data.totalElements);
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        this.$message.error(err.msg);
      })
    },

    /*
      导出入参
    */
    exportDetail () {
      let params = {
        tradeType: this.type,
        supplierId: Number(localStorage.getItem('supplier_id')),
        corpId: this.detailInfo.activeCorp,
        page: this.currentPage - 1,
        pageSize: this.pagesize,
        trxType: this.trxType,
      }
      if (this.time.length === 0) {
        params.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD') + " 00:00:00";
        params.endDate = moment().format('YYYY-MM-DD') + " 23:59:59";
      } else {
        params.startDate = moment(this.time[0]).format('YYYY-MM-DD') + " 00:00:00";
        params.endDate = moment(this.time[1]).format('YYYY-MM-DD') + " 23:59:59";
      }
      window.open(`${myhostname}${jzbApi.r4gys_exportSettleTransactionDetail}?access_token=${localStorage.getItem('token')}&${buildURL(params)}`);
    },

    /* 展开子表格 */
    expandChange (row, expandedRows) {
      if (!row.expand) {  // 先判断该行是否已经展开了
        r4gysSettleTransactionDetail({settleNo: row.settleNo})
          .then(res => {
            if (res.code === 200) {
              row.expand = true     // 设置展开行是打开的
              row.child = res ? res.data.map((item, index) => {
                item.serialNum = index + 1;
                return item;
              }) : []
            } else {
              row.expand = true     // 设置展开行是打开的
            }
          }).catch(err => {
          this.$message.error(err.msg);
        })
      } else {
        row.expand = false;
      }
    },

    /* 切换每页条数 */
    handleSizeChange (val) {
      this.pagesize = val
      this.currentPage = 1;
      this.initData();
    },

    /* 切换当前页码 */
    handleCurrentChange (val) {
      this.currentPage = val;
      this.initData();
    }
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
    .select-wrap {
        display: flex;
        align-items: center;
        margin: 20px 0;
    }

    .select-wrap > div {
        padding-right: 20px;
    }

    .checkbox {
      margin-left: 15px;
    }

    .select-company{
      margin-right: auto;
    }
    .el-range-editor.el-input__inner {
      height: 32px;
      line-height: 32px;
      margin-top: 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/purseSetting/record/components/RuiGuTransDetail.vue